import { logger } from '../logger';
var anonymizeContext = function (ctx) {
    var evtCtx = ctx.event.context;
    evtCtx.locale = '';
    evtCtx.timezone = '';
    evtCtx.userAgent = '';
    return ctx;
};
// NB: Removing anonymous and user id happen in `normalize.ts` in Segment plugin
// as it would otherwise be added back in there
export var ddAnonymizeContextPlugin = function () {
    return {
        name: 'Anonymous Context',
        type: 'enrichment',
        version: '0.0.1',
        isLoaded: function () { return true; },
        load: function () {
            logger.debug('Enabling Anonymous Context plugin');
            return Promise.resolve();
        },
        track: anonymizeContext,
        identify: anonymizeContext,
        page: anonymizeContext,
        group: anonymizeContext,
        alias: anonymizeContext,
        screen: anonymizeContext,
    };
};
//# sourceMappingURL=index.js.map